export enum ShopThumbType {
  PCP = 'pcp',
  COMMISSION = 'commission',
}
